import { API_PATH } from 'common/constants/services';
import useQuery from 'hook/useQuery';
import { Notice } from 'model/notice';
import React, { useEffect, useState } from 'react';

export default function useNoticeDetail(id: number) {
  const {
    getQuery: { data },
  } = useQuery<Notice>(API_PATH.ANNOUNCEMENT_DETAIL(id));

  return { data: data?.data };
}
